import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {PersistConfig} from 'redux-persist'
import {persistReducer} from 'redux-persist'
import persistStorage from 'redux-persist/lib/storage'

export interface IScoringAccuracyTipsModalState {
  lastTimeUserOpenedScoreModalForAudioScoring: number;
  lastTimeThisTipWasDisplayed: number;
  hasUserOptedToHideThisTip: boolean;
}

const initialState: IScoringAccuracyTipsModalState = {
  lastTimeUserOpenedScoreModalForAudioScoring: 0,
  lastTimeThisTipWasDisplayed: 0,
  hasUserOptedToHideThisTip: false,
};

export const scoringAccuracyTipsModalSlice = createSlice({
  name: `scoringAccuracyTipsModal`,
  initialState: initialState,

  reducers: (create) => ({
    lastTimeUserOpenedScoreModalForAudioScoringReducer: create.reducer((state, action: PayloadAction<IScoringAccuracyTipsModalState["lastTimeUserOpenedScoreModalForAudioScoring"]>) => {
      state.lastTimeUserOpenedScoreModalForAudioScoring = action.payload;
    }),
    lastTimeThisTipWasDisplayedReducer: create.reducer((state, action: PayloadAction<IScoringAccuracyTipsModalState["lastTimeThisTipWasDisplayed"]>) => {
      state.lastTimeThisTipWasDisplayed = action.payload;
    }),
    hasUserOptedToHideThisTipReducer: create.reducer((state, action: PayloadAction<IScoringAccuracyTipsModalState["hasUserOptedToHideThisTip"]>) => {
      state.hasUserOptedToHideThisTip = action.payload;
    }),
  }),
  selectors: {
    lastTimeUserOpenedScoreModalForAudioScoringSelector: (state: IScoringAccuracyTipsModalState) => state.lastTimeUserOpenedScoreModalForAudioScoring,
    lastTimeThisTipWasDisplayedSelector: (state: IScoringAccuracyTipsModalState) => state.lastTimeThisTipWasDisplayed,
    hasUserOptedToHideThisTipSelector: (state: IScoringAccuracyTipsModalState) => state.hasUserOptedToHideThisTip,
  },
});

const persistenceConfig: PersistConfig<IScoringAccuracyTipsModalState> = {
  key: scoringAccuracyTipsModalSlice.name, // Only persist things from this slice.
  storage: persistStorage,
  // whitelist: [], // An optional list of only the sub-keys to persist.=
};

const baseReducer = scoringAccuracyTipsModalSlice.reducer;
export const scoringAccuracyTipsModalReducer = persistReducer<IScoringAccuracyTipsModalState>(persistenceConfig, baseReducer);
